import { nanoid } from "nanoid";
import {b64toBlob} from "./BlobUtils";

export class Upload {

  constructor(dataUrl) {

    const __self = this;
    __self.complete = false;
    return this.init(__self, dataUrl);

  }

  get response() {

    return {
      id: this.id,
      url: this.url,
      ext: this.ext,
      type: this.type,
      error: this.error,
      complete: this.complete,
    }

  }

  get getId() {
    return this.id;
  }

  set setId(id) {
    this.id = id;
  }

  get getUrl() {
    return this.url;
  }

  set setUrl(url) {
    this.url = url;
  }

  get getError() {
    return this.error;
  }

  set setError(error) {
    this.error = error;
  }

  get getComplete() {
    return this.complete;
  }

  set setComplete(complete) {
    this.complete = complete;
  }

  // Methods

  async init(__self, dataUrl) {

    // The unique id we're using to track everything throughout the upload process
    __self.id   = nanoid();

    const id    = __self.id;

    const blob  = await __self.getBlob(dataUrl);

    if (blob.error && typeof(blob.error) == "string") {
      __self.error = blob.error;
      return __self.response;
    }

    const ext   = __self.getFileExtension(blob);

    const type  = __self.getFileType(blob);

    const file  = __self.buildFile(ext, blob);

    const blobs = __self.getBlobList(file);

    __self.ext = ext;
    __self.type = type;

    await Promise.all(
      blobs.map((blob, index) => __self.buildUploadRequest(__self, blob, index, id, ext, file, type))
    )
    .then(res => {
      return __self.stitchBlobs(id, ext, type)
    })
    .then(res => {

      __self.url = res;
      __self.complete = true;

    })
    .catch(err => {

      console.warn("An error occured while uploading the video:", err);

      alert(err);

      __self.error = err
      __self.complete = true;
    })
    ;

    return __self.response;

  }

  // Helper functions

  /**
   * takes a data url and gets the associated blob
   */
  async getBlob(dataUrl) {

   return await fetch(dataUrl)
   .then(r => r.blob())
   .then(b => b)
   .catch(e => {
     console.warn("Error with blob: ", e);
     return {
       error: "Something went wrong, please try again",
     };
   })
   ;

  }

  /**
   * Gets the file extension for a given blob
   */
  getFileExtension(blob) {

    const blobType = blob.type.split(";")[0];

    let ext = {"text/vnd.in3d.3dml":[".3dml"],"video/3gpp2":[".3g2"],"video/3gpp":[".3gp"],"audio/x-aac":[".aac"],"audio/adpcm":[".adp"],"audio/x-aiff":[".aif",".aifc",".aiff"],"video/x-ms-asf":[".asf",".asx"],"text/x-asm":[".asm",".s"],"audio/basic":[".au",".snd"],"video/x-msvideo":[".avi"],"image/bmp":[".bmp"],"image/prs.btif":[".btif"],"text/x-c":[".c",".cc",".cpp",".cxx",".dic",".h",".hh"],"image/cgm":[".cgm"],"image/x-cmx":[".cmx"],"text/plain":[".conf",".def",".diff",".in",".ksh",".list",".log",".pl",".text",".txt"],"text/css":[".css"],"text/csv":[".csv"],"text/vnd.curl":[".curl"],"text/vnd.curl.dcurl":[".dcurl"],"image/vnd.djvu":[".djv",".djvu"],"text/prs.lines.tag":[".dsc"],"audio/vnd.dts":[".dts"],"audio/vnd.dts.hd":[".dtshd"],"image/vnd.dwg":[".dwg"],"image/vnd.dxf":[".dxf"],"audio/vnd.nuera.ecelp4800":[".ecelp4800"],"audio/vnd.nuera.ecelp7470":[".ecelp7470"],"audio/vnd.nuera.ecelp9600":[".ecelp9600"],"message/rfc822":[".eml",".mht",".mhtml",".mime",".nws"],"audio/vnd.digital-winds":[".eol"],"text/x-setext":[".etx"],"text/x-fortran":[".f",".f77",".f90",".for"],"video/x-f4v":[".f4v"],"image/vnd.fastbidsheet":[".fbs"],"image/x-freehand":[".fh",".fh4",".fh5",".fh7",".fhc"],"video/x-fli":[".fli"],"video/x-flv":[".flv"],"text/vnd.fmi.flexstor":[".flx"],"text/vnd.fly":[".fly"],"image/vnd.fpx":[".fpx"],"image/vnd.fst":[".fst"],"video/vnd.fvt":[".fvt"],"image/g3fax":[".g3"],"image/gif":[".gif"],"text/vnd.graphviz":[".gv"],"video/h261":[".h261"],"video/h263":[".h263"],"video/h264":[".h264"],"text/html":[".htm",".html"],"image/x-icon":[".ico"],"text/calendar":[".ics",".ifb"],"image/ief":[".ief"],"text/vnd.sun.j2me.app-descriptor":[".jad"],"text/x-java-source":[".java"],"image/jpeg":[".jpe",".jpeg",".jpg"],"video/jpm":[".jpgm",".jpm"],"video/jpeg":[".jpgv"],"audio/midi":[".kar",".mid",".midi",".rmi"],"audio/vnd.lucent.voice":[".lvp"],"video/mpeg":[".m1v",".m2v",".mpa",".mpe",".mpeg",".mpg"],"audio/mpeg":[".m2a",".m3a",".mp2",".mp2a",".mp3",".mpga"],"audio/x-mpegurl":[".m3u"],"video/vnd.mpegurl":[".m4u",".mxu"],"video/x-m4v":[".m4v"],"video/x-matroska":[".mkv"],"text/troff":[".man",".me",".ms",".roff",".t",".tr"],"text/vnd.curl.mcurl":[".mcurl"],"image/vnd.ms-modi":[".mdi"],"video/mj2":[".mj2",".mjp2"],"image/vnd.fujixerox.edmics-mmr":[".mmr"],"video/quicktime":[".mov",".qt"],"video/x-sgi-movie":[".movie"],"video/mp4":[".mp4",".mp4v",".mpg4"],"audio/mp4":[".mp4a"],"image/vnd.net-fpx":[".npx"],"audio/ogg":[".oga",".ogg",".spx"],"video/ogg":[".ogv"],"text/x-pascal":[".p",".pas"],"image/x-portable-bitmap":[".pbm"],"image/x-pict":[".pct",".pic"],"image/x-pcx":[".pcx"],"image/x-portable-graymap":[".pgm"],"image/png":[".png"],"image/x-portable-anymap":[".pnm"],"image/x-portable-pixmap":[".ppm"],"image/vnd.adobe.photoshop":[".psd"],"text/x-python":[".py"],"audio/vnd.ms-playready.media.pya":[".pya"],"video/vnd.ms-playready.media.pyv":[".pyv"],"video/webm":[".webm"],"audio/x-pn-realaudio":[".ra",".ram"],"image/x-cmu-raster":[".ras"],"image/x-rgb":[".rgb"],"image/vnd.fujixerox.edmics-rlc":[".rlc"],"audio/x-pn-realaudio-plugin":[".rmp"],"text/richtext":[".rtx"],"text/vnd.curl.scurl":[".scurl"],"text/sgml":[".sgm",".sgml"],"text/vnd.wap.si":[".si"],"text/vnd.wap.sl":[".sl"],"text/vnd.in3d.spot":[".spot"],"image/svg+xml":[".svg",".svgz"],"image/tiff":[".tif",".tiff"],"text/tab-separated-values":[".tsv"],"text/uri-list":[".uri",".uris",".urls"],"text/x-uuencode":[".uu"],"text/x-vcard":[".vcf"],"text/x-vcalendar":[".vcs"],"video/vnd.vivo":[".viv"],"audio/x-wav":[".wav"],"audio/x-ms-wax":[".wax"],"image/vnd.wap.wbmp":[".wbmp"],"video/x-ms-wm":[".wm"],"audio/x-ms-wma":[".wma"],"text/vnd.wap.wml":[".wml"],"text/vnd.wap.wmlscript":[".wmls"],"video/x-ms-wmv":[".wmv"],"video/x-ms-wmx":[".wmx"],"video/x-ms-wvx":[".wvx"],"image/x-xbitmap":[".xbm"],"image/vnd.xiff":[".xif"],"image/x-xpixmap":[".xpm"],"image/x-xwindowdump":[".xwd"]}

    if (typeof(ext[blobType]) == 'undefined') {
      throw new Error("Your file type is not supported");
    }

    return ext[blobType][0];

  }

  /**
   * Gets the type of the given blob
   */
  getFileType(blob) {

    return blob.type.split("/")[0];

  }

  /**
   * Builds a new file from the blob.
   */
  buildFile(ext, blob, type) {

    return new File(
      [blob],
      `upload${ext}`,
      {
        type: blob.type,
      }
    );

  }

  /**
   * Builds a blob list by splitting the file.
   */
  getBlobList(file) {

    const sliceSize = 3500000;

    const result    = [];

    for (let i = 0; i < file.size; i += sliceSize) {
      const blobSlice = file.slice(i, i + sliceSize);
      result.push(blobSlice);
    }


    return result;

  }

  /**
   * Gets the base 64 data url for the given file.
   */
  getBase64(file) {

    return new Promise((resolve, reject) => {

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = error => reject(error);

    });

  }

  /**
   * Builds an fetch request for each blob so it can be uploaded
   */
  async buildUploadRequest(__self, blob, index, id, ext, file) {

    const url      = `${window.Shopify?.routes?.root}a/gc/api/blob/upload/${id}/${index}`;
    const formData = new FormData();
    const fileData = await __self.getBase64(blob).then(data => data);

    formData.append("ext", ext);
    formData.append("size", blob.size);
    formData.append("type", file.type);
    formData.append("blob", fileData);

    const options = {
      method: 'POST',
      body: formData,
    };

    return new Promise((resolve, reject) => {
      fetch(url, options)
      .then(res => {

        return res.json();

      })
      .then(res => {

        if (res.status == "error") {

          throw new Error(res.message);

        }

        resolve(res);

      })
      .catch(err => {

        reject(err);

      });
    });

  }

  /**
   * Sends a fetch request to stitch the given set of blobs
   */
  stitchBlobs(id, ext, type) {

    return new Promise((resolve, reject) => {

      fetch(`${window.Shopify?.routes?.root}a/gc/api/stitch/upload/${id}?ext=${ext}&type=${type}`)
      .then(res => {

        return res.json();

      })
      .then(res => {

        if (res.status == "error") {
          console.warn("An error occurred uploading the file", res);
          throw new Error(res.message);

        }

        resolve(res.url);

      })
      .catch(err => {

        console.warn("An error occurred uploading the file", err);

        reject(err);

      });

    });

  }

}
